<template>
  <div>
    <!-- <PageTitle
      title="User View"
      :backBtn="true"
      :editRoute="'/user/edit/' + this.$route.params.id"
      :permission="'User Edit'"
      :resetPasswordPermission="'User Reset Password'"
      :resetpass="true"
      @onResetPassword="onReset()"
    /> -->
       <PageTitle
      title="User View"
      :backBtn="true"
      :editRoute="'/user/edit/' + this.$route.params.id"
      :permission="'User Edit'"
    />
    <v-container fluid>
      <!-- Page Title -->

      <v-row>
        <v-col cols="12" sm="12" md="4" lg="4">
          <v-card>
            <v-img
              :src="
                user.image ? user.image : require('@/assets/profile-img.png')
              "
            ></v-img>
            <v-list two-line class="pl-10 pr-10">
              <v-list-item>
                <v-list-item-action>
                  <v-icon color="indigo">mdi-account</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title
                    class="font-weight-black text-decoration-underline"
                    >Username</v-list-item-title
                  >
                  <v-list-item-title>{{ user.username }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-divider inset></v-divider>
              <v-list-item>
                <v-list-item-action>
                  <v-icon color="indigo">mail</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title
                    class="font-weight-black text-decoration-underline"
                    >Email</v-list-item-title
                  >
                  <v-list-item-title>{{ user.email }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-divider inset></v-divider>
              <v-list-item>
                <v-list-item-action>
                  <v-icon color="indigo">mdi-account-group-outline</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title
                    class="font-weight-black text-decoration-underline"
                    >Role</v-list-item-title
                  >
                  <v-list-item-title>{{ roleName }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-card>
        </v-col>
        <v-col cols="12" sm="12" md="8" lg="8">
          <v-card>
            <v-card-title>Access</v-card-title>
            <v-list two-line class="pa-0">
              <v-list-item>
                <v-list-item-action>
                  <v-icon color="indigo">mdi-silverware-fork-knife</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>{{ kotAccessLabel }}</v-list-item-title>
                  <v-list-item-sub-title>KOT access</v-list-item-sub-title>
                </v-list-item-content>
              </v-list-item>
              <v-divider inset></v-divider>
              <v-list-item>
                <v-list-item-action>
                  <v-icon color="indigo">mdi-cellphone-basic</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>{{ phone }}</v-list-item-title>
                  <v-list-item-sub-title>Phone number</v-list-item-sub-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import { required, email, max, regex } from "vee-validate/dist/rules";
import jwt_decode from "jwt-decode";
import { User } from "../../../models/User";

import {
  extend,
  ValidationObserver,
  ValidationProvider,
  setInteractionMode,
} from "vee-validate";

setInteractionMode("eager");

extend("required", {
  ...required,
  message: "{_field_} is required",
});

extend("max", {
  ...max,
  message: "{_field_} may not be greater than {length} characters",
});

extend("email", {
  ...email,
  message: "Email must be valid",
});

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
  },
  computed: {
    roleName() {
      return this.user.roles && this.user.roles[0] && this.user.roles[0].name
        ? this.user.roles[0].name
        : "";
    },
    phone() {
      return this.user.contacts && this.user.contacts.phone
        ? this.user.contacts.phone
        : "";
    },
    kotAccessLabel() {
      const labels = { 1: "KOT", 2: "Kitchen", 3: "Waiter" };
      const types = Array.isArray(this.user.kot_access_types)
        ? this.user.kot_access_types
        : [];
      const names = types.map((value) => labels[Number(value)]).filter(Boolean);
      return names.length ? names.join(", ") : "";
    },
  },
  data: () => ({
    name: "",
    email: "",
    isAdmin: false,
    value: String,
    select: null,
    roles: [],
    items: ["Item 1", "Item 2", "Item 3", "Item 4"],
    checkbox: null,
    user: new User(),
    loginedUser: new User(),
    errors: [],
    oldUserDetails: new User(),
    messages: [],
  }),

  methods: {
    submit() {
      this.$refs.observer.validate();
      this.EditUser();
    },
    async onReset() {
      this.$confirm("Do you want to Reset Password ?").then((res) => {
        if (res) {
          let Credentials = this.$route.params.id;
          this.$store
            .dispatch("user/AdminResetPassword", Credentials)
            .then((res) => {
              this.succeeed = true;
              window.open(res.data.credential, "_blank");
            })
            .catch((err) => {
              this.messages.push(err.data);
              // this.$router.push("/pages/404");
              console.log(err);
            });
        }
      });
    },
    Reset() {
      this.user = this.oldUserDetails;
      this.$refs.observer.reset();
    },
    EditUser() {
      const selectedRoles = [];
      let userId = this.$route.params.id;
      this.$store
        .dispatch("user/EditUser", {
          id: userId,
          username: this.user.username,
          firstName: this.user.firstName,
          lastName: this.user.lastName,
          address: JSON.stringify(this.user.address),
          email: this.user.email,
          contacts: JSON.stringify(this.user.contacts),
          conmpany: this.user.username,
          password: this.user.password,
          roles: this.user.role,
          image: this.user.role,
        })
        .then((res) => {
          this.succeeed = true;
          this.$toast.success("User edited successfully");
        })
        .catch((err) => {
          this.messages = err.data.title;
          this.$toast.error("Edit failed");
        });
    },
    GetRoles() {
      this.$store
        .dispatch("user/GetRoles")
        .then((res) => {
          this.roles = res.data;
        })
        .catch((err) => {
          this.messages = err.data.title;
        });
    },
    getUser() {
      let userId = this.$route.params.id;

      this.$store
        .dispatch("user/GetSingleUser", userId)
        .then((res) => {
          this.succeeed = true;

          this.user = new User().initialise(res.data);
          if (this.user.image) {
            this.user.image = this.user.image + "?t=" + Date.now();
          }
        })
        .catch((err) => {
          this.messages.push(err.data);
          // this.$router.push("/pages/404");
          console.log(err);
        });
    },
  },
  created() {
    this.GetRoles();
    this.getUser();
  },
};
</script>
